import axios from 'axios';
import React, {useState, useEffect} from 'react';
import { toast } from 'react-toastify';
import { Modal, ModalBody, ModalHeader, Row, Col, ModalFooter, Button } from 'reactstrap';
import Loader from 'react-loader-spinner';
import JSONPretty from 'react-json-pretty';

export default function ViewNotificationHash({data, setToggle}) {
  const [modal, setModal] = useState(false)
  const [loading, setLoading] = useState(false)
  console.log("data", data);
  const [loadingBtns, setLoadingBtns] = useState(false)

  const toggleFunc = () => {
    setModal(curr => !curr)
  }

  const closeBtn = <button className="close" 
    onClick={() => setModal(false)}> &times; </button>;

  return (
    <>
      <Modal isOpen={modal} toggle={toggleFunc} backdrop='static' size='lg'>
        <ModalHeader toggle={toggleFunc} close={closeBtn}>
          Notification Details: {data.site_name}
        </ModalHeader>
        <ModalBody className='px-5'>
          {
            loading ? <Loader type="Puff" color="#00BFFF" height={60} width={60} className='pc-loader' />
              : <>
              <Row className='my-2'>
                <Col lg={12}>
                  <h6 className='my-0'><strong>Notification hash from pipeline</strong></h6>
                  <JSONPretty id="json-pretty" data={data.notification_hash}></JSONPretty>
                </Col>
              </Row>
            </>
          }
        </ModalBody>
        <ModalFooter>
          <Button color='light' onClick={() => setModal(false)}> Close </Button>
        </ModalFooter>
      </Modal>
      <button className='btn btn-xs btn-light mx-1' onClick={toggleFunc}>Notification Details</button>
    </>
  )
}
